import { createImg } from "../../../DomUtilities/ElementsCreator";
import Item from "../../../Models/Item";
import Variant from "../../../Models/Variant";
import { isNumber } from "../../../Validations/Validations";
import ServiceVariantList from "./ServiceVariantList";
import UpdateOrder from "../../../Models/UpdateOrder/UpdateOrder";
import UpdateItem from "../../../Models/UpdateOrder/UpdateItem";

export default class UpdateItemRow {
	listItem: HTMLLIElement;
	serviceList: HTMLLIElement;
	item: Item;
	updatedOrder: UpdateOrder;
	readonly MINIMUM_QUANTITY: number = 1;
	readonly MAXIMUM_QUANTITY: number = 99;

	constructor(item: Item, updatedOrder: UpdateOrder) {
		this.updatedOrder = updatedOrder;
		this.item = item;

		this.init();
	}

	private init() {
		this.listItem = document.createElement('li');
		this.serviceList = document.createElement('li');
		const serviceVariantListContainer = document.createElement('ul');
		this.serviceList.appendChild(serviceVariantListContainer);

		new ServiceVariantList(serviceVariantListContainer, this.item.services, this.updatedOrder, this.item);
		this.createItemTile();
		this.addItemClickListener();
	}

	private createItemTile() {
		this.listItem.classList.add('item-accordion');

		const expandIconSrc: string = "/assets/chevron_right.svg";
		const expandIcon = createImg(expandIconSrc, `expand more icon`);
		const itemName = document.createTextNode(`${this.item.name}`);
		const spanExpand = document.createElement('span');
		const spanInput = document.createElement('span');

		spanExpand.appendChild(expandIcon);
		spanExpand.appendChild(itemName);
		spanInput.classList.add('custom-input-number')

		const itemInputCount = document.createElement('input');
		itemInputCount.type = 'number';
		itemInputCount.value = `${this.item.count}`;
		itemInputCount.min = `${this.MINIMUM_QUANTITY}`;
		itemInputCount.max = `${this.MAXIMUM_QUANTITY}`;

		const customInput = document.createElement('div');
		customInput.classList.add('input-number');
		const increaseIcon = createImg(expandIconSrc, 'increase icon');
		const decreaseIcon = createImg(expandIconSrc, 'increase icon');

		const br = document.createElement('br');
		const hr = document.createElement('hr');

		customInput.appendChild(increaseIcon);
		customInput.appendChild(br);
		customInput.appendChild(decreaseIcon);
		spanInput.appendChild(itemInputCount);
		spanInput.appendChild(customInput);

		const totalSpan = document.createElement('span');
		const itemTotal = document.createTextNode(`${this.TotalCost}`);
		totalSpan.appendChild(itemTotal);

		this.listItem.appendChild(spanExpand);
		this.listItem.appendChild(spanInput);
		this.listItem.appendChild(totalSpan);
		this.listItem.appendChild(hr);

		this.addInputdNumberEventsListeners(itemInputCount, increaseIcon, decreaseIcon);;
	}

	private get TotalCost(): number {
		return this.item.services.reduce((previousValue, currentValue) => previousValue + this.getTotalserviceVariantsCost(currentValue.variants), 0);
	}

	private getTotalserviceVariantsCost(variants: Array<Variant>): number {
		return variants.reduce((previousValue, currentValue) => previousValue + currentValue.cost, 0);
	}

	private addItemClickListener() {
		this.listItem.onclick = () => {
			if (this.listItem.classList.contains("item-accordion--open")) {
				this.listItem.classList.remove("item-accordion--open");
			} else {
				this.listItem.classList.add("item-accordion--open");
			}
		}
	}

	private isValidQuantity(value: string): boolean {
		const quantity = Number(value);
		return !!value && !isNaN(quantity) && quantity >= this.MINIMUM_QUANTITY && quantity <= this.MAXIMUM_QUANTITY;
	}

	private addInputdNumberEventsListeners(input: HTMLInputElement, increase: HTMLImageElement, decrease: HTMLImageElement) {
		increase.onclick = (event) => {
			event.stopPropagation();
			const newValue = `${parseInt(input.value) + 1}`;
			if (this.isValidQuantity(newValue)) {
				input.value = newValue;
				this.updateItemCount(Number(input.value));
			}
		}

		decrease.onclick = (event) => {
			event.stopPropagation();
			const newValue = `${parseInt(input.value) - 1}`;
			if (this.isValidQuantity(newValue)) {
				input.value = newValue;
				this.updateItemCount(Number(input.value));
			}
		}

		input.onclick = (event) => event.stopPropagation();

		input.onkeypress = (event) => {
			const inputKey = event.key;
			const isValidInput = isNumber(inputKey) && input.value.length < 2;

			if (!isValidInput) {
				event.preventDefault();
			}
		}

		input.onkeyup = () => {
			if (!input.value) {
				input.value = "1";
			}

			this.updateItemCount(Number(input.value));
		}
	}

	private updateItemCount(newCount: number) {
		let curUpdatedItem = this.updatedOrder.items.find((item) => item.id === this.item.id);

		if (this.item.count !== newCount) {
			if (curUpdatedItem) {
				curUpdatedItem.count = newCount;
			} else {
				this.updatedOrder.items.push(new UpdateItem(this.item.id, newCount));
			}
		} else if (curUpdatedItem && curUpdatedItem.services.length === 0) {
			this.updatedOrder.items = this.updatedOrder.items.filter((updatedItem: UpdateItem) => updatedItem.id !== this.item.id);
		}
	}
}
